
import { defineComponent } from 'vue'
import { formatDateWithTimeFromBackend, formatDateFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    props: {
        isNeedCar: {
            type: Boolean,
            default: false,
        },
        ftlBidId: {
            type: Number,
            default: null,
        },
        logistBidId: {
            type: Number,
            default: null,
        },
        ftlTypeName: {
            type: String,
            default: null,
        },
        dopOrderNumber: {
            type: String,
            default: null,
        },
        shipmentTypeName: {
            type: String,
            default: null,
        },
        takeDate: {
            type: String,
            default: null,
        },
        takeTime: {
            type: String,
            default: null,
        },
        actNumber: {
            type: String,
            default: null,
        },
        actCreatedAt: {
            type: String,
            default: null,
        },
        autoDurationClient: {
            type: Number,
            default: null,
        },
        autoCount: {
            type: Number,
            default: null,
        },
        manager: {
            type: Object,
            default: null,
        },
        logist: {
            type: Object,
            default: null,
        },
        companyName: {
            type: String,
            default: null,
        },
        annotation: {
            type: String,
            default: null,
        },
        createdAt: {
            type: String,
            default: null,
        },
        receivedBy: {
            type: String,
            default: null,
        },
        deliveryDate: {
            type: String,
            default: null,
        },
        autoDuration: {
            type: Number,
            default: null,
        },
        number: {
            type: String,
            default: null,
        },
        createdBy: {
            type: Object,
            default: null,
        },
    },
    setup() {
        return {
            formatDateWithTimeFromBackend,
            formatDateFromBackend
        }
    }
})
